import { useTranslation } from 'react-i18next';
import { statusTone, minutesSince, splitNumbers } from './coldChainModel';

const TONE = {
  green: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300',
  amber: 'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300',
  red: 'bg-rose-50 text-rose-700 dark:bg-rose-500/10 dark:text-rose-300',
  grey: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
};

export default function ColdStatusChip({ status, lastReadingAt, nowMs = Date.now() }) {
  const { t } = useTranslation();
  const label = {
    ok: t('coldChain.status.ok', 'OK'),
    pending: t('coldChain.status.pending', 'Pending'),
    excursion: t('coldChain.status.excursion', 'Excursion'),
    no_data: t('coldChain.status.noData', 'No data'),
    unknown: t('coldChain.status.unknown', 'Waiting for data'),
  }[status] ?? status;
  const mins = status === 'no_data' ? minutesSince(lastReadingAt, nowMs) : null;
  return (
    <span data-status={status} className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${TONE[statusTone(status)]}`}>
      {label}
      {mins !== null && (
        <span className="font-normal">
          {'· '}
          {splitNumbers((o) => t('coldChain.lastReadingAgo', 'last reading {{n}} min ago', o), { n: mins }, (v) => <bdi key="n">{v}</bdi>)}
        </span>
      )}
    </span>
  );
}
